import myAxios from "./myAxios";
import * as apiActions from "./apiActions";
import { areSpecsRunning, modalPaths } from "../components/ScrollReader/helpers";

const writeToOrMockStorage = ({ data }) => {
  if (!areSpecsRunning()) {
    Storage.purgeLocalStorage();
    saveAuthToken(data.auth_token);
    if (data.user && data.user_settings) {
      saveAccountData({ user: data.user, user_settings: data.user_settings });
    } else {
      saveAccountData(data);
    }
  }
};

export const setEmail = email => ({
  type: "SET_EMAIL",
  email
});

export const setSigninError = errorMsg => ({
  type: "SET_SIGNIN_ERROR",
  errorMsg
});

export const setSignupError = errorSignUpMsg => ({
  type: "SET_SIGNUP_ERROR",
  errorSignUpMsg
});

export const setSelectedLanguage = lang => ({
  type: "SET_SELECTED_LANGUAGE",
  lang
});

export const closeLanguageMenu = () => ({
  type: "CLOSE_LANGUAGE_MENU"
});

export const toggleLanguageMenu = () => ({
  type: "TOGGLE_LANGUAGE_MENU"
});

export const closeUserMenu = () => ({
  type: "CLOSE_USER_MENU"
});

export const toggleUserMenu = () => ({
  type: "TOGGLE_USER_MENU"
});

export const toggleMobileUserSubmenu = () => ({
  type: "TOGGLE_MOBILE_USER_SUBMENU"
});

export const setLocationHash = hash => dispatch => {
  window.location.hash = hash;
};

export const openModal = () => dispatch => {
  dispatch({
    type: "OPEN_MODAL"
  });
};

export const openModalWithCallback = (callback, callbackType, callbackArgs) => dispatch => {
  dispatch({
    type: "OPEN_MODAL_WITH_CALLBACK",
    callback,
    callbackType,
    callbackArgs
  });
  dispatch(setLocationHash(modalPaths.signIn));
};

export const closeModal = () => dispatch => {
  dispatch({ type: "CLOSE_MODAL" });
  // dispatch(setLocationHash(""));
};

export const setPassword = password => ({
  type: "SET_PASSWORD",
  password
});

export const setRepeatPassword = repeatPassword => ({
  type: "SET_REPEAT_PASSWORD",
  repeatPassword
});

export const toggleSubscribeToEmails = () => ({
  type: "TOGGLE_SUBSCRIBE_TO_EMAILS"
});

const reactedPopComment = (popComments, args) =>
  args.parent_type === "PopCommentReply"
    ? popComments
        .find(
          popComment =>
            popComment.id === args.commented_id && popComment.comment_type === args.commented_type
        )
        .replies.find(reply => reply.id === args.parent_id)
    : popComments.find(
        popcomment =>
          popcomment.id === args.parent_id && popcomment.comment_type === args.parent_type
      );

export const submitSignup = (
  email,
  password,
  repeat_password,
  subscribe_to_emails,
  successCreatedMsg
) => dispatch => {
  dispatch({ type: "PROCESSING_ON" });
  myAxios
    .post(routes().sign_up, {
      email,
      password,
      repeat_password,
      subscribe_to_emails
    })
    .then(() => {
      dispatch(setSignupError(""));
      dispatch(setPassword(""));
      dispatch(setRepeatPassword(""));
      setNoticeSuccess(successCreatedMsg);
      dispatch({ type: "PROCESSING_OFF" });
    })
    .catch(err => {
      if (err.response && typeof err.response.data !== "undefined") {
        const { fields } = err.response.data;
        if (typeof fields !== "undefined") {
          dispatch(
            setSignupError(
              fields.map(field => `${Object.keys(field)[0]} ${field[Object.keys(field)[0]]}`)
            )
          );
        }
      } else {
        console.error(err);
      }
      dispatch({ type: "PROCESSING_OFF" });
    });
};

export const submitSignin = loginEndpoint => (
  loginParams,
  callback,
  callbackType,
  callbackArgs
) => dispatch => {
  dispatch({ type: "PROCESSING_ON" });
  if (
    loginParams.failedMsg &&
    (!loginParams.auth_token ||
      !loginParams.auth_token_secret ||
      !loginParams.auth_user_id ||
      !loginParams.username)
  ) {
    setSigninError(loginParams.failedMsg);
  }
  myAxios
    .post(loginEndpoint, loginParams)
    .then(response => {
      myAxios.setAuthToken(response.data.auth_token);
      writeToOrMockStorage(response);
      if (callbackType !== "openModal") {
        // dispatch(closeModal());
      }
    })
    .then(() => {
      dispatch(setSigninError(""));
      dispatch(setSignupError(""));
      return dispatch(
        apiActions.fetchInitialData({
          withPopComments: callbackType !== "fetchDrawerContent",
          args: callbackArgs && callbackArgs[0]
        })
      );
    })
    .then(fetchedData => {
      if (callback !== null) {
        switch (callbackType) {
          case "toggleLike":
            if (fetchedData.currentEpisodeData && !fetchedData.currentEpisodeData.liked) {
              callback(callbackArgs[1]);
            }
            break;
          case "popReactionSend":
            const popComments = fetchedData.currentEpisodePopCommentsData;
            const args = callbackArgs[1];
            if (
              (args.action === "dislike" && reactedPopComment(popComments, args).disliked) ||
              (args.action === "like" && reactedPopComment(popComments, args).liked)
            ) {
              break;
            } else {
              callback(callbackArgs[1]);
            }
            break;
          case "fetchDrawerContent":
          case "openModal":
          case "openReplyForm":
          case "poppinFormOpen":
            callback(...callbackArgs.slice(1, callbackArgs.length));
            break;
          default:
            break;
        }
      }
      dispatch({ type: "PROCESSING_OFF" });
    })
    .catch(err => {
      err.response && err.response.data
        ? dispatch(setSigninError(err.response.data.message))
        : console.error(err);
      dispatch({ type: "PROCESSING_OFF" });
    });
};

export const handleFBSignin = submitSignin(routes().sign_fb);
export const handleMailSignin = submitSignin(routes().sign_in);
export const handleTwitterSignin = submitSignin(routes().sign_twitter);
export const handleGoogleSignin = submitSignin(routes().sign_google);
export const handleAppleSignin = submitSignin(routes().sign_apple);
